export const currentUser = ({ token, client }) => ({
  HTTPMethod: "get",
  path: "/myself",
  queryParams: { client },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
